import {
  SIGN_IN_START,
  SIGN_OUT_START,
  SIGN_IN_SUCCESS,
  SIGN_IN_ERROR,
  SIGN_OUT_END,
  UPDATE_USER_DATA,
} from 'web-shared/consts/action-types';
import { Action } from './types/Action';
import { AuthReduxState } from './types/AuthReduxState';

export const initialState: AuthReduxState = {
  error: false,
  loading: false,
  user: null,
  signedOut: false,
};

export default function authReducer(state = initialState, action: Action) {
  switch (action.type) {
    case SIGN_IN_START:
    case SIGN_OUT_START:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case SIGN_IN_SUCCESS:
      return {
        error: false,
        loading: false,
        signedOut: false,
        user: {
          ...action.payload,
        },
      };
    case UPDATE_USER_DATA: {
      if (!state.user) return state;
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    }
    case SIGN_IN_ERROR:
      return {
        error: true,
        loading: false,
        user: null,
        signedOut: false
      };
    case SIGN_OUT_END:
      return {
        error: false,
        loading: false,
        user: null,
        signedOut: true
      };
    default:
      return state;
  }
}